'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
}), exports.api = api, exports.pagination = pagination, exports.aggregatePagination = aggregatePagination, exports.aggregate = aggregate, exports.parseContent = parseContent;

var _crossFetch = require('cross-fetch'),
    _crossFetch2 = _interopRequireDefault(_crossFetch),
    _querystring = require('querystring'),
    _querystring2 = _interopRequireDefault(_querystring);

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

function _toConsumableArray(a) {
  if (Array.isArray(a)) {
    for (var b = 0, c = Array(a.length); b < a.length; b++) {
      c[b] = a[b];
    }

    return c;
  }

  return Array.from(a);
}

var fetchOptions = {
  method: 'GET',
  mode: 'cors',
  credentials: 'omit'
};

function api(a) {
  var b = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      c = Object.assign({
    format: 'json',
    action: 'query',
    redirects: ''
  }, b);
  Object.keys(c).forEach(function (f) {
    c[f] === void 0 && delete c[f];
  }), a.origin && (c.origin = a.origin);

  var d = a.apiUrl + '?' + _querystring2.default.stringify(c);

  return (0, _crossFetch2.default)(d, Object.assign({
    headers: a.headers
  }, fetchOptions)).then(function (f) {
    return f.json();
  }).then(function (f) {
    if (f.error) throw new Error(f.error.info);
    return f;
  });
}

function pagination(a, b, c) {
  return api(a, b).then(function (d) {
    var f = {
      results: c(d),
      query: b.srsearch
    };

    if (d['continue']) {
      var g = Object.keys(d['continue']).filter(function (j) {
        return 'continue' !== j;
      })[0],
          h = d['continue'][g];
      b[g] = h, f.next = function () {
        return pagination(a, b, c);
      };
    }

    return f;
  });
}

function aggregatePagination(a) {
  var b = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : [];
  return a.then(function (c) {
    var d = [].concat(_toConsumableArray(b), _toConsumableArray(c.results));
    return c.next ? aggregatePagination(c.next(), d) : d;
  });
}

var pageLimit = 500;

function aggregate(a, b, c, d, f) {
  var g = 5 < arguments.length && void 0 !== arguments[5] ? arguments[5] : [];
  return b.list = c, b[f + 'limit'] = pageLimit, api(a, b).then(function (h) {
    var j = [].concat(_toConsumableArray(g), _toConsumableArray(h.query[c].map(function (l) {
      return l[d];
    }))),
        k = h['query-continue'] || h.continue;

    if (k) {
      var l = k[c] && k[c][f + 'from'] || k[f + 'continue'];
      return b[f + 'continue'] = l, b[f + 'from'] = l, aggregate(a, b, c, d, f, j);
    }

    return j;
  });
}

var headingPattern = /(==+)(?:(?!\n)\s?)((?:(?!==|\n)[^])+)(?:(?!\n)\s?)(==+)/g;

function getHeadings(a) {
  for (var b = void 0, c = []; null !== (b = headingPattern.exec(a));) {
    c.push({
      level: b[1].trim().length,
      text: b[2].trim(),
      start: b.index,
      end: b.index + b[0].length
    });
  }

  return c;
}

function parseContent(a) {
  var b = getHeadings(a),
      c = Math.min.apply(Math, _toConsumableArray(b.map(function (j) {
    var k = j.level;
    return k;
  }))),
      d = b.map(function (j, k) {
    var l = b[k + 1],
        m = a.substring(j.end, l ? l.start : void 0).trim();
    return {
      title: j.text,
      level: j.level - c,
      id: k,
      content: m,
      items: []
    };
  }),
      f = function lastParentLevel(j, k) {
    if (0 === k) return null;

    for (var l = j - 1; 0 <= l; l--) {
      if (d[l].level < k) return d[l].id;
    }

    return null;
  };

  d.forEach(function (j, k) {
    j.parent = f(k, j.level);
  });

  var g = {
    items: []
  },
      h = function findSection(j) {
    return d.find(function (k) {
      return j === k.id;
    });
  };

  return d.forEach(function (j) {
    null === j.parent ? g.items.push(j) : h(j.parent).items.push(j);
  }), d.forEach(function (j) {
    delete j.id, delete j.parent, delete j.level, j.items.length || delete j.items;
  }), g.items;
}